import { render, staticRenderFns } from "./apple-auth.vue?vue&type=template&id=3ae4b548&scoped=true"
import script from "./apple-auth.vue?vue&type=script&lang=js"
export * from "./apple-auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4b548",
  null
  
)

export default component.exports